export const generateProps = (tableInstance) => ({
    setQuery: tableInstance.setGlobalFilter,
    query: tableInstance.state.globalFilter
});
